import * as React from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {observable} from "mobx";
import {observer} from "mobx-react";

import {library} from "@fortawesome/fontawesome-svg-core";
import {faExclamationTriangle, faSpinner} from "@fortawesome/free-solid-svg-icons";


import {AsyncAjax} from "../../../PageBuilder/utils/JQueryAsync";

import {PrinterSelection} from "../../../Settings/Tabs/PrinterSelection";
import {RNCheckBox} from "shared/controls/SingleInputs/RNCheckBox/RNCheckBox";
import {StoreBase} from "shared/utilities/Store/StoreBase";
import {DocumentSettings, PageOptions, PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";


library.add(faSpinner);
library.add(faExclamationTriangle);

@observer
export class PrinterTab extends React.Component<DriveTabProps, DriveTabState> {
    static defaultProps: Partial<DriveTabProps> = {};
    public store:PrinterOptions;
    constructor(props: DriveTabProps) {
        super(props);

    }

    componentDidMount(){

    }

    componentWillUnmount(){

    }
    public render() {

        return (
            <div>
                <RNCheckBox<DocumentSettings> Store={this.props.DocumentOptions.DocumentSettings} PropertyName={"PrintWhenCreated"} Label={'Print pdf automatically when created'} onChange={()=>this.forceUpdate()}/>
                <SwitchContainer>
                    {this.props.DocumentOptions.DocumentSettings.PrintWhenCreated &&
                    <SearchableSelect<DocumentSettings> Label={"Printer to use"} PropertyName={"PrinterId"} Store={this.props.DocumentOptions.DocumentSettings}
                                                        onChange={() => this.forceUpdate()}>
                        {rednaoVar.Printers.map(printer =>
                            <option key={printer.id} value={printer.id}>{printer.name}</option>
                        )}
                    </SearchableSelect>
                    }
                </SwitchContainer>

            </div>

        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface DriveTabProps {
    DocumentOptions:PDFDocumentOptions;
}

interface DriveTabState {
    LoadingFolders:boolean;
    FolderList:{name:string,id:string}[];
    ErrorMessage:string;
}

export class PrinterOptions extends StoreBase{
    @observable printWhenCreated:boolean;
    @observable printerId:string;
    @observable printerLabel:string;


    protected LoadDefaultValues() {
        this.printWhenCreated=false;
        this.printerId='';
        this.printerLabel='';
    }
}

//#endregion "My Region"